import React from "react";

function PagePropertiesAdvancedSubscribe() {
  return <>Advanced code embeds for CSS and Javascript are available when you subscribe.</>;
}

export default PagePropertiesAdvancedSubscribe;
